<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Journey wijzigen</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeEditJourneyDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="ma-0 pa-1" v-if="feedback" :value="true" type="warning">
      {{ feedback }}
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="EditJourneyForm" lazy-validation>
        <v-text-field
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          hide-details
          label="Naam Customer Journey"
          v-model.trim="selectedJourney.name"
          background-color="background"
          autocomplete
          prepend-icon="none"
          required
        ></v-text-field>
        <v-text-field
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          label="Omschrijving"
          v-model.trim="selectedJourney.description"
          autocomplete
          hint="Vul een korte omschrijving in van deze  Journey"
          background-color="background"
          prepend-icon="info"
          persistent-hint
          required
        ></v-text-field>

        <v-text-field
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          hide-details
          label="Type journey"
          :value="journeyType"
          prepend-icon="how_to_vote"
          background-color="background"
          disabled
        ></v-text-field>

        <v-select
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          :item-color="companyPrimaryColor"
          hide-details
          :items="languages"
          item-text="name"
          item-value="code"
          prepend-icon="flag"
          v-model="selectedJourney.selectedLanguages"
          background-color="background"
          multiple
          label="Selecteert talen"
        >
        </v-select>

        <v-select
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          :item-color="companyPrimaryColor"
          hide-details
          v-if="selectedJourney.type == 'global' && userRole == 'superadmin'"
          background-color="background"
          :items="companies"
          item-text="name"
          item-value="id"
          prepend-icon="business"
          v-model="journeyCompanies"
          v-on:input="createCompaniesObject()"
          label="Select onderneming"
          multiple
        >
        </v-select>

        <v-select
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          :item-color="companyPrimaryColor"
          hide-details
          background-color="background"
          :items="filterTypes"
          item-text="name"
          item-value="id"
          prepend-icon="mdi-form-select"
          v-model="selectedJourney.filter"
          @change="filterSelected()"
          label="Gebruiken voor specifieke behandelingen"
        >
        </v-select>

        <div
          v-if="selectedJourney.filter && selectedJourney.filter != 'none'"
          class="pa-4 ma-4 ml-5 mr-0 ext-center"
          style="background-color: #f6f7fb"
        >
          <p>
            <strong
              >Geef de extacte naam van de behandeling op per regel.</strong
            >
          </p>
          <div
            v-for="(field, index) in selectedJourney.filterFields"
            :key="index + changes"
          >
            <v-text-field
              v-if="index == 0"
              class="mt-3"
              outlined
              :color="companyPrimaryColor"
              hide-details
              dense
              label="Naam behandeling"
              v-model="selectedJourney.filterFields[index]"
              append-outer-icon="mdi-bbr"
              background-color="menu"
            ></v-text-field>
            <v-text-field
              v-else
              class="mt-3"
              outlined
              :color="companyPrimaryColor"
              hide-details
              dense
              label="Naam behandeling"
              v-model="selectedJourney.filterFields[index]"
              background-color="menu"
              append-outer-icon="mdi-close"
              @click:append-outer="removeFilterField(index)"
            ></v-text-field>
          </div>
          <div class="text-center ma-2">
            <v-btn
              small
              fab
              dark
              :color="companyPrimaryColor"
              @click="newFilterField()"
            >
              <v-icon darken>add</v-icon>
            </v-btn>
          </div>
        </div>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeEditJourneyDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :disabled="!changed"
              :depressed="!changed"
              :dark="changed"
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              rounded
              :color="companySecondaryColor"
              @click="updateJourney()"
            >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import { bus } from "../../main";
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import { log } from "util";

export default {
  name: "edit-journey-form",
  props: {
    selectedJourney: Object,
    selectedJourneyOriginal: Object,
    activeComp: Object,
    companies: Array,
  },
  data() {
    return {
      journeyTypes: [
        {
          name: "Algemeen",
          id: "global",
        },
        {
          name: "Individueel",
          id: "business",
        },
      ],
      feedback: null,
      errors: [],
      journeyCompanies: [],
      journeyCompaniesBoolean: {},
      feedback: "",
      filterTypes: [
        {
          name: "Versturen na alle behandelingen",
          id: "none",
        },
        {
          name: "Versturen na specifieke behandelingen",
          id: "include",
        },
        {
          name: "Specifieke behandelingen uitsluiten",
          id: "exclude",
        },
      ],
      changes: 0,
    };
  },

  created: function() {
    bus.$on("infoUpdate", this.updateModalInfo);
  },

  methods: {
    filterSelected() {
      this.selectedJourney.filterFields = [""];
      this.changes++;
    },

    removeFilterField(index) {
      this.selectedJourney.filterFields.splice(index, 1);
      this.changes++;
    },

    newFilterField() {
      this.selectedJourney.filterFields.push("");
      this.changes++;
    },

    updateModalInfo() {
      let activeCompanies = this.selectedJourney.companies;

      // // Active Journey Key filter uit Object
      Object.filter = (obj, predicate) =>
        Object.keys(obj)
          .filter((key) => predicate(obj[key]))
          .reduce((res, key) => ((res[key] = obj[key]), res), {});

      let filterActiveCompanies = Object.filter(
        activeCompanies,
        (company) => company == true,
      );
      this.journeyCompanies = _.keysIn(filterActiveCompanies);
      this.createCompaniesObject();
    },

    checkJourneyType() {
      this.journeyCompaniesBoolean = {};
      let journeyCompaniesObject = this.journeyCompaniesBoolean;
      let company = this.activeComp;
      // console.log("Even checken: " + this.activeComp);
      if (this.selectedJourney.type == "business") {
        journeyCompaniesObject[company] = true;
      }
    },
    createCompaniesObject() {
      this.journeyCompaniesBoolean = {};
      let journeyCompaniesArray = this.journeyCompanies;
      let journeyCompaniesObject = this.journeyCompaniesBoolean;
      journeyCompaniesArray.forEach((company) => {
        journeyCompaniesObject[company] = true;
      });
    },
    closeEditJourneyDialog() {
      this.showNewDialog = false;
      this.$emit("editJourneyDialogChange", this.showNewDialog);
    },

    updateJourney() {
      if (
        this.selectedJourney.name &&
        this.selectedJourney.description &&
        this.selectedJourney.type
      ) {
        db.collection("journeys")
          .doc(this.selectedJourney.id)
          .update({
            name: this.selectedJourney.name,
            description: this.selectedJourney.description,
            companies: this.journeyCompaniesBoolean,
            selectedLanguages: this.selectedJourney.selectedLanguages,
            type: this.selectedJourney.type,
            filter: this.selectedJourney.filter
              ? this.selectedJourney.filter
              : "none",
            filterFields: this.selectedJourney.filterFields
              ? this.selectedJourney.filterFields
              : new Arrray(),
          })
          .then(() => {
            db.collection("log")
              .add({
                time: new Date(),
                logType: "info",
                user: this.userFirstName + " " + this.userLastName,
                userType: this.userRole,
                company: this.userCompany,
                actionType: "User Action",
                action: "Journey gewijzigd: " + this.activeComp.name,
                extra:
                  "<b>ORIGINELE GEGEVENS</b> " +
                  "<br>" +
                  "<b>Naam:</b> " +
                  this.selectedJourneyOriginal.name +
                  "<br>" +
                  "<b>Omschrijving:</b> " +
                  this.selectedJourneyOriginal.description +
                  "<br>" +
                  "<b>Type:</b> " +
                  this.selectedJourneyOriginal.type +
                  "<br>" +
                  "<b>Taal:</b> " +
                  this.selectedJourneyOriginal.selectedLanguages +
                  "<br>" +
                  "<b>Bedrijven:</b> " +
                  JSON.stringify(this.selectedJourneyOriginal.companies) +
                  "<br><br>" +
                  "<b>AAGENPASTE GEGEVENS</b> " +
                  "<br>" +
                  "<b>Naam:</b> " +
                  this.selectedJourney.name +
                  "<br>" +
                  "<b>Omschrijving:</b> " +
                  this.selectedJourney.description +
                  "<br>" +
                  "<b>Type:</b> " +
                  this.selectedJourney.type +
                  "<br>" +
                  "<b>Taal:</b> " +
                  this.selectedJourneyOriginal.selectedLanguages +
                  "<br>" +
                  "<b>Bedrijven:</b> " +
                  JSON.stringify(this.selectedJourney.companies),
              })
              .catch((error) => {
                console.error("Error updating Journey: ", error);
                db.collection("log").add({
                  time: new Date(),
                  logType: "error",
                  user: this.userFirstName + " " + this.userLastName,
                  userType: this.userRole,
                  company: this.userCompany,
                  actionType: "User Action",
                  action: "Error updating Journey: " + this.activeComp.mame,
                  extra: JSON.stringify(error),
                });
              });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeEditJourneyDialog();
            this.$refs.EditJourneyForm.reset();
          })
          .catch(() => {
            console.error("Error adding Journey: ", error);
          });
      } else {
        this.feedback = "Vul alle velden in om een Journey toe te voegen";
      }
    },
  },

  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    journeyType() {
      if (this.selectedJourney.type == "global") {
        return "Algemeen";
      } else if (this.selectedJourney.type == "business") {
        return "Individueel";
      }
    },

    changed() {
      if (
        _.isEqual(this.selectedJourney, this.selectedJourneyOriginal) == false
      ) {
        return true;
      } else {
        return false;
      }
    },

    languages() {
      let activeLanguages = [];
      if (this.activeComp.languages) {
        this.activeComp.languages.forEach((language) => {
          let activeLanguage = {};
          if (language == "nl") {
            activeLanguage.code = "nl";
            activeLanguage.name = "Nederlands";
            activeLanguages.push(activeLanguage);
          } else if (language == "en") {
            activeLanguage.code = "en";
            activeLanguage.name = "Engels";
            activeLanguages.push(activeLanguage);
          }
        });

        return activeLanguages;
      } else {
        return activeLanguages;
      }
    },
  },
};
</script>
